"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logExecutionTime = exports.Logger = void 0;
var logger_1 = require("./logger");
Object.defineProperty(exports, "Logger", { enumerable: true, get: function () { return logger_1.Logger; } });
var logExecutionTime_1 = require("./logExecutionTime");
Object.defineProperty(exports, "logExecutionTime", { enumerable: true, get: function () { return logExecutionTime_1.logExecutionTime; } });
//# sourceMappingURL=main.js.map